import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  // Check if user is authenticated
  if (!user.id) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if admin access is required
  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/lessons" replace />;
  }
  
  return children;
};

export default ProtectedRoute; 